import teslaClone from '../assets/images/teslaproject.png'
import GitHubIcon from "@mui/icons-material/GitHub"
import LinkIcon from '@mui/icons-material/Link';
import movieApp from '../assets/images/movieapp.jpg'


export const PortfolioData = [
  {
    title: 'Movie App',
    caption: 'A movie website using OMDb API. ',
    description: 'This project is built using React,Sass for styling,ReduxToolkit for state management',
    website: 'https://tonecinema.netlify.app/',
    projectImg: movieApp,
    linkIcon: <LinkIcon />,
    gitLink: 'https://github.com/TonyMike/MovieApp',
    gitIcon: <GitHubIcon />
  },
  {
    title: 'Tesla Clone App',
    caption: 'This project is replicate of Tesla official website',
    description: 'This project is built using React,Styled Component, Redux',
    website: 'https://tonymike-tesla-clone.netlify.app/',
    projectImg: teslaClone,
    linkIcon: <LinkIcon />,
    gitLink: 'https://github.com/TonyMike/tesla-clone',
    gitIcon: <GitHubIcon />
  }
]
